import { html, ViewTemplate, ref, when } from '@microsoft/fast-element';
import type { KnowledgeBlockModal } from './knowledge-block-modal';
import { RoutePath } from '../../../utils';
import { MarketDepthKnowledgeBlock } from './knowledge-block-content/market-depth-knowledge-block';
import { ExecutionKnowledgeBlock } from './knowledge-block-content/execution-knowledge-block';
import { BuyerDashboardKnowledgeBlock } from './knowledge-block-content/buyer-dashboard-knowledge-block';
import { SellerDashboardKnowledgeBlock } from './knowledge-block-content/seller-dashboard-knowledge-block';

export const KnowledgeBlockModalTemplate: ViewTemplate<KnowledgeBlockModal> = html`
  <right-side-modal
    classes="knowledge-block-modal"
    ${ref('knowledgeBlockModal')}
    :show="${(x) => x.show}"
    allowOverlayClose="true"
    @modalClosing=${(x) => x.closeModal()}
    width="${(x) => x.width}"
    header="${(x) => x.title}"
    buttons="false"
  >
    <div class="knowledge-block-modal-wrapper">
      <div class="knowledge-block-modal-content-wrapper">
        ${when((x) => x.currentPath == RoutePath.MARKET_DEPTH, MarketDepthKnowledgeBlock)}
        ${when((x) => x.currentPath == RoutePath.SELLER_DASHBOARD, SellerDashboardKnowledgeBlock)}
        ${when(
          (x) => x.currentPath == RoutePath.SELLER_ANALYTICS,
          html<KnowledgeBlockModal>`
            <p class="">I'm in seller analytics</p>
          `,
        )}
        ${when((x) => x.currentPath == RoutePath.EXECUTION, ExecutionKnowledgeBlock)}
        ${when((x) => x.currentPath == RoutePath.BUYER_DASHBOARD, BuyerDashboardKnowledgeBlock)}
      </div>
    </div>
  </right-side-modal>
`;